import { defineComponent as _defineComponent } from 'vue'
import UsertypeRadioButton from "@/views/pages/auth/reg/UsertypeRadioButton.vue";
import {computed, getCurrentInstance, onBeforeUnmount, onMounted, reactive, ref, watch} from "vue";
import {WebFormModel} from "capitalist-shared/src/core/model";
import {RemoteRequestState} from "capitalist-shared/src/core/remote";
import ProfileUpdateLegal from "@/views/pages/profile/ProfileUpdateLegal.vue";
import ProfileUpdateIndividual from "@/views/pages/profile/ProfileUpdateIndividual.vue";
import RegularFormNumberedItemHeading
  from "@/views/pages/profile/RegularFormNumberedItemHeading.vue";
import axios from "axios";
import LoadingIndicator from "@/components/loaders/LoadingIndicator.vue";
import {onBeforeRouteLeave} from "vue-router/composables";
import {scrollToElement} from "@/core/scroll";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileUpdateSelect',
  setup(__props) {


class UsertypeSelectModel extends WebFormModel {
  loadingState = new RemoteRequestState()
  values = {
    userType: ''
  }

  profile = null
  hasActiveRequest = false
  request = null

  checkState() {
    this.loadingState.loadStart();
    return axios.get('/webapi/profile/update?call=checkState')
      .then((response) => {
        this.loadingState.loadEnd();
        this.profile = response.data.profile;
        this.hasActiveRequest = response.data.hasActiveRequest;
        this.request = response.data.request;
        return response.data;
      })
      .catch((error) => {
        this.checkAxiosError(error);
        this.loadingState.loadError();
        throw error;
      })
  }
}

const model = reactive(new UsertypeSelectModel())

const isIndividual = computed(() => model.values.userType === 'INDIVIDUAL');
const isLegalEntity = computed(() => model.values.userType === 'LEGAL');

const individualForm = ref(null)
const legalForm = ref(null)

watch(() => model.values.userType, (value) => {
  if (value === 'INDIVIDUAL') {
    legalForm.value?.hideForm();
    individualForm.value?.activateForm();
  } else if (value === 'LEGAL') {
    individualForm.value?.hideForm();
    legalForm.value?.activateForm();
  }
})

const doConfirmLeave = ref(true);

const disabled = computed(() => {
  return !model.loadingState.isLoaded
    || !updateAvailable.value
    || model.hasActiveRequest
    || (model.values.userType != '') && (individualForm.value?.busy || legalForm.value?.busy);
})

const selectorRef = ref(null)

const reloadState = () => {
  scrollToElement(selectorRef.value, 500);
  model.values.userType = '';
  return model.checkState();
}

onMounted(() => {
  reloadState()
})

const updateAvailable = computed(() => {
  return model.profile?.updateAvailable;
})

const isConfirmationRequired = () => {
  const result = (model.values.userType !== '') && model.loadingState.isLoaded && updateAvailable.value;
  return result;
}

const confirmationMessage = () => {
  const i18n = getCurrentInstance()?.proxy.$i18n;
  const message = 'Вы действительно хотите покинуть страницу? Несохраненные данные будут потеряны.';
  return i18n ? String(i18n.t(message)) : message;
}

const confirmLeave = () => {
  if (!isConfirmationRequired()) return true;
  return window.confirm(confirmationMessage());
}

onBeforeRouteLeave((to, from, next) => {
  if (confirmLeave()) {
    next();
  } else {
    next(false);
  }
})

const beforeWindowUnload = (e) => {
  if (!isConfirmationRequired()) return true;

  (e || window.event).returnValue = confirmationMessage();

  if (!confirmLeave()) {
    // Cancel the event
    e.preventDefault()
    // Chrome requires returnValue to be set
    e.returnValue = ''
  }
  return confirmationMessage();
}

window.addEventListener('beforeunload', beforeWindowUnload)

onBeforeUnmount(() => {
  window.removeEventListener('beforeunload', beforeWindowUnload)
})


return { __sfc: true,UsertypeSelectModel, model, isIndividual, isLegalEntity, individualForm, legalForm, doConfirmLeave, disabled, selectorRef, reloadState, updateAvailable, isConfirmationRequired, confirmationMessage, confirmLeave, beforeWindowUnload, UsertypeRadioButton, ProfileUpdateLegal, ProfileUpdateIndividual, RegularFormNumberedItemHeading, LoadingIndicator }
}

})